<div *ngIf="visible" [hidden]="!active">
    <ng-content></ng-content>
    <!-- <ng-container
        *ngIf="template"
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ data: data }">
    </ng-container> -->
</div>